export default __webpack_public_path__ + "static/LEAPS-423e5eac19fd0eb5cc693c10e339a89e.png";